import { Component } from '@angular/core';
import { LoadingController,App } from 'ionic-angular';
import { AppState } from '../../../../../app/app.global';
import { BooksList } from '../bookslist/bookslist';
import { HttpService } from '../../../../../providers/service/httpservice';
import { BOOKUSERINFO,DUEDATELIST,HISTORYLIST } from '../../../../../providers/config/serviceurl';
import { StorageService } from '../../../../../providers/service/storageservice';

@Component({
  selector: 'books-overview',
  templateUrl: 'mybooks.html'
})

export class BooksOverview{
	
	user:any={};
	bookinfo:any={id:'',name:'',nownum:'0',duenum:'0',hisnum:'0',balance:'0.0'};//首页显示数据
	nowbooklist:any=[];//当前借阅列表
	historybooklist:any=[];//历史借阅列表
	duedatebooklist:any=[];//过期借阅列表
	constructor(private loadCtrl:LoadingController,public global: AppState,public appCtrl: App,
		private httpService:HttpService) {
    this.user = StorageService.getObj('currentUser');
    this.bookinfo = StorageService.getObj('bookinfo');
    if(this.bookinfo==null||this.bookinfo.id==null){
    	this.bookinfo =  {id:'',name:'',nownum:'0',duenum:'0',hisnum:'0',balance:'0.0'};
    }
    this.nowbooklist = StorageService.getObj('nowbooklist');
    this.historybooklist = StorageService.getObj('historybooklist');
    this.duedatebooklist = StorageService.getObj('duedatebooklist');
    this.getBookUserInfo();
    this.getDueDateList();
    this.getHistoryList();
	}
	
	//查询个人信息 欠款和当前借阅册数 及详细
  getBookUserInfo(){
  	var params = {'account':this.user.userId};
  	this.httpService.post(BOOKUSERINFO,params).then(anyObj =>this.handleBookInfoList(anyObj));
  }
  
  handleBookInfoList(obj:any){
  	if(obj){
  		this.bookinfo.id= obj.id;
  		this.bookinfo.name= this.user.personName;
  		this.bookinfo.nownum= obj.ondueCount;
  		this.bookinfo.balance= obj.balance;
  		this.nowbooklist = obj.list;
  		StorageService.setObj("bookinfo",this.bookinfo);
  		StorageService.setObj("nowbooklist",this.nowbooklist);
  	}
  }
  
  //获取过期册数  及详细
  getDueDateList(){
  	var params = {'account':this.user.userId};
  	this.httpService.post(DUEDATELIST,params).then(anyObj =>this.handleBookDueDateList(anyObj));
  }
	
	handleBookDueDateList(obj:any){
		if(obj){
			this.bookinfo.duenum = obj.overdueCount;
			this.duedatebooklist = obj.list;
			StorageService.setObj("bookinfo",this.bookinfo);
  		StorageService.setObj("duedatebooklist",this.duedatebooklist);
		}
	}
	
	//查询获取借阅历史图书数 及 详细借阅历史
  getHistoryList(){
  	var params = {'account':this.user.userId};
  	this.httpService.post(HISTORYLIST,params).then(anyObj =>this.handleBookHistoryList(anyObj));
  }
	
	handleBookHistoryList(obj:any){
		if(obj){
			this.bookinfo.hisnum = obj.historyNum;
			this.historybooklist = obj.list;
			StorageService.setObj("bookinfo",this.bookinfo);
  		StorageService.setObj("historybooklist",this.historybooklist);
		}
	}
	
	
	openBooksList(type:string){
		let name = "";
		var list:any=[];
		if(type == 'current'){
			name = "当前借阅";
			list = this.nowbooklist;
		}else if(type == 'past'){
			name = "过期图书";
			list = this.duedatebooklist;
		}else if(type == 'history'){
			name = "历史借阅";
			list = this.historybooklist;
		}else if(type == 'arrears'){
			name = '欠款金额';
		}
		this.appCtrl.getRootNav().push(BooksList,{"listTitle":name,"type":type,"list":list});
	}
	

}


// WEBPACK FOOTER //
// ./src/pages/application/life/books/overview/mybooks.ts